import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const ALIGNS = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
};

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  border: {
    borderBottom: '2px solid #999',
    width: '100%',
  },
  content: {
    color: '#333',
    fontFamily: 'roboto',
    fontSize: 18,
    fontWeight: 700,
    textTransform: 'uppercase',
    paddingBottom: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  },
  [ALIGNS.CENTER]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  [ALIGNS.LEFT]: {
    paddingRight: theme.spacing(2),
  },
  [ALIGNS.RIGHT]: {
    paddingLeft: theme.spacing(2),
  },
}));

function DividerV2({ align, children }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {align !== ALIGNS.LEFT && <div className={classes.border} />}
      {children && (
        <span className={clsx(classes.content, classes[align])}>
          {children}
        </span>
      )}
      {align !== ALIGNS.RIGHT && <div className={classes.border} />}
    </div>
  );
}

DividerV2.defaultProps = {
  align: ALIGNS.LEFT,
};

DividerV2.propTypes = {
  align: PropTypes.oneOf(Object.values(ALIGNS)),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
};

export default DividerV2;
